export const botAvatar =
  "https://robohash.org/liberovelitdolores.bmp?size=50x50&set=set1";
export const userAvatar =
  "http://icons.iconarchive.com/icons/visualpharm/must-have/256/User-icon.png";
